export default "__VITE_ASSET__CnETLJ0w__"